export const setupChecklistKeys = {
  all: ['restricted', 'setupChecklist'] as const,
  state: (tenantId?: number | null) => [...setupChecklistKeys.all, 'state', tenantId ?? null] as const,
};
